import AxiosConfig from '../../../config/AxiosConfig';

const useCreateOrUpdateSavOrder = () => {
  const createOrUpdateSavOrder = async (id, data) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/savdraft/${id}/createOrUpdateSavOrder`
      )
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to add lines to SAV:', err);
      throw new Error(`addLinesToSav failed: ${err?.message}`);
    }
  };

  return {
    createOrUpdateSavOrder,
  };
};

export default useCreateOrUpdateSavOrder;
